import Addition from './Addition'
import Anzan from './Anzan'
import MulBase from './MulBase'
import Mul from './Mul'
import Squared from './Squared'
import Division from './Division'
import Negative from './Negative'
import Columns from './Column'
import AbacusRandom from './AbacusRandom'
import Mul25x25 from './Mul25x25'

export default {
	Addition,
	Negative,
	AbacusRandom,
	Anzan,
	MulBase,
	Mul,
	Squared,
	Division,
	Columns,
	Mul25x25,
}
